import { render, staticRenderFns } from "./WaitListCard.vue?vue&type=template&id=0d7e30b4&scoped=true&"
import script from "./WaitListCard.vue?vue&type=script&lang=js&"
export * from "./WaitListCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7e30b4",
  null
  
)

/* custom blocks */
import block0 from "./WaitListCard.vue?vue&type=custom&index=0&blockType=div&class=wait-list__item"
if (typeof block0 === 'function') block0(component)

export default component.exports